import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "23002/LW8dGH5wKOXF5zheV", "Shop", undefined);

import { _decorator, Component, Node, ScrollView, Texture2D, MeshRenderer, Label, Color, Toggle, Line, Sprite, color, tween, v3 } from 'cc';
import { E_ADEventType, E_AdType, E_EventType, E_MainLayerType, E_PlatformType, E_ResPath } from './common/EnumBase';
import { App } from './common/manager/App';
import { E_PoolType } from './common/manager/PoolManager';
import { E_SoundType } from './common/manager/SoundManager';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
var E_ShopType;

(function (E_ShopType) {
  E_ShopType[E_ShopType["Line"] = 0] = "Line";
  E_ShopType[E_ShopType["Ball"] = 1] = "Ball";
})(E_ShopType || (E_ShopType = {}));

export var Shop = (_dec = ccclass('Shop'), _dec2 = property(Node), _dec3 = property(Label), _dec4 = property(Node), _dec5 = property(Node), _dec6 = property(Node), _dec7 = property(Node), _dec8 = property(Node), _dec9 = property(Node), _dec10 = property(Node), _dec11 = property(Node), _dec12 = property(Node), _dec13 = property(Node), _dec14 = property([Texture2D]), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Shop, _Component);

  function Shop() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_coin", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_coin", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_close", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_title", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_lineShow", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_ballShow", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_ball", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "sv_ball", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "sv_line", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_ad", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_adCoin", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_buy", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "texArr", _descriptor13, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_ballPrice", []);

    _defineProperty(_assertThisInitialized(_this), "_lineCArr", []);

    _defineProperty(_assertThisInitialized(_this), "_ballName", []);

    _defineProperty(_assertThisInitialized(_this), "_ballOwn", "");

    _defineProperty(_assertThisInitialized(_this), "_ballCur", 0);

    _defineProperty(_assertThisInitialized(_this), "_ballSelet", 0);

    _defineProperty(_assertThisInitialized(_this), "_lineOwn", "");

    _defineProperty(_assertThisInitialized(_this), "_lineCur", 0);

    _defineProperty(_assertThisInitialized(_this), "_lineUnlock", "");

    _defineProperty(_assertThisInitialized(_this), "_lineSelect", 0);

    _defineProperty(_assertThisInitialized(_this), "_type_select", E_ShopType.Ball);

    _defineProperty(_assertThisInitialized(_this), "_texArr", new Map());

    return _this;
  }

  var _proto = Shop.prototype;

  _proto.onLoad = function onLoad() {
    this._texArr = App.DataMgr.initBallTex();
    this._ballPrice = [500, 700, 900, 1100, 1300, 1500, 1700, 1900, 2100, 2300, 2500, 2700, 2900, 3100, 3300, 3500, 3700, 3900, 4100, 4300, 4500, 4700, 4900, 5100];
    this._ballName = ["Skeleton", "TaiChiBall", "Billiards", "YoYoBall", "Golf", "VoleyBall", "BowlingBall", "FootBall", "BasketBall", "PinkBall", "ColourfulBall", "Candy", "Coockie", "Egg", "Heart", "Orange", "PlanetEarth", "Pokeball", "SmileB", "SmileD", "SmileKaka", "Snowball", "Threads", "USA"];
    this._lineCArr = [this.colorFromHex("#ffffff"), this.colorFromHex("#ba0000"), this.colorFromHex("#fadd16"), this.colorFromHex("#37fc16"), this.colorFromHex("#16fdfa"), this.colorFromHex("#166dfd"), this.colorFromHex("#02245b"), this.colorFromHex("#4712c0"), this.colorFromHex("#fc17f4"), this.colorFromHex("#fe80d6")];
  };

  _proto.colorFromHex = function colorFromHex(hex) {
    var c_aim = color();
    Color.fromHEX(c_aim, hex);
    return c_aim;
  };

  _proto.start = function start() {
    // [3]
    this._ballOwn = App.DataMgr.ballOwn;
    this._ballCur = App.DataMgr.ballCur;
    this._ballSelet = this._ballCur;
    this.initBall();
    this._lineUnlock = App.DataMgr.lineUnlock;
    this._lineOwn = App.DataMgr.lineOwn;
    this._lineCur = App.DataMgr.lineCur;
    this._lineSelect = this._lineCur;
    this.initLine();
    App.GameCtrl.addBtnEvent(this.node, this.btn_event.bind(this));
    this.sv_ball.active = true;
    this.sv_line.active = true;
    this.updateCoin();
    this.addEventListener();
    this.n_ad.active = false;
    this.n_buy.active = false;
    this.sv_line.position = v3(App.DataMgr.visibleSize.width, this.sv_line.position.y, 0);
    this.updateSelect_ball();
  };

  _proto.onDestroy = function onDestroy() {
    this.removeEventListener();
  };

  _proto.addEventListener = function addEventListener() {
    App.AdEventMgr.addEventLintener(E_ADEventType.video_showOver, this.handle_adSucc, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.AdEventMgr.removeEvent(this);
  }
  /**更新金币 */
  ;

  _proto.updateCoin = function updateCoin() {
    this.lbl_coin.string = App.DataMgr.coin + "";
  };

  _proto.enter = function enter() {
    this.node.setPosition(v3(0, 0, 0));
    var n_act = null;

    if (this._type_select == E_ShopType.Ball) {
      n_act = this.sv_ball;
    } else {
      n_act = this.sv_line;
    }

    n_act.scale = v3(0, 0, 0);
    tween(n_act).to(0.3, {
      scale: v3(1, 1, 1)
    }, {
      easing: "backOut"
    }).start();
    this.initLine();
  } // actLine () {
  // }

  /**初始化球数据 */
  ;

  _proto.initBall = function initBall() {
    var allBall = this.sv_ball.getComponent(ScrollView).content.children;
    var n_item = null;
    var mat = null;

    for (var i = 0; i < allBall.length; i++) {
      n_item = allBall[i].getChildByName("n_item");
      mat = n_item.getComponent(MeshRenderer).materials[0];
      mat.setProperty("mainTexture", this.texArr[i]);
      this.loadTex(mat, E_ResPath.Tex_BallRoot + this._texArr.get(i)); //遮罩

      var n_mask = allBall[i].getChildByName("n_mask");
      var isOwn = this._ballOwn.indexOf(i + "") != -1;
      n_mask.active = !isOwn; //金币图标跟值

      var n_coin = allBall[i].getChildByName("coinTIp");
      var n_lblCoin = allBall[i].getChildByName("lbl_coin");
      n_lblCoin.active = !isOwn;
      n_coin.active = !isOwn;

      if (!isOwn) {
        var _allBall$i$getChildBy;

        var lbl_coin = (_allBall$i$getChildBy = allBall[i].getChildByName("lbl_coin")) === null || _allBall$i$getChildBy === void 0 ? void 0 : _allBall$i$getChildBy.getComponent(Label);
        lbl_coin.string = this._ballPrice[i] + "";
        var c_aim = App.DataMgr.coin >= this._ballPrice[i] ? Color.WHITE : Color.RED;
        lbl_coin.color = c_aim;
      }
    }
  };

  _proto.loadTex = function loadTex(mat, path) {
    App.ResMgr.getTex(path, function (tex) {
      mat.setProperty("mainTexture", tex);
    });
  }
  /**更新小球状态 */
  ;

  _proto.updateBallState = function updateBallState() {
    var allBall = this.sv_ball.getComponent(ScrollView).content.children;
    var n_item = null;

    for (var i = 0; i < allBall.length; i++) {
      n_item = allBall[i].getChildByName("n_item");
      var isOwn = this._ballOwn.indexOf(i + "") != -1; //金币图标跟值

      var n_coin = allBall[i].getChildByName("coinTIp");
      var n_lblCoin = allBall[i].getChildByName("lbl_coin");

      if (!isOwn) {
        var _allBall$i$getChildBy2;

        var lbl_coin = (_allBall$i$getChildBy2 = allBall[i].getChildByName("lbl_coin")) === null || _allBall$i$getChildBy2 === void 0 ? void 0 : _allBall$i$getChildBy2.getComponent(Label);
        lbl_coin.string = this._ballPrice[i] + "";
        var c_aim = App.DataMgr.coin >= this._ballPrice[i] ? Color.WHITE : Color.RED;
        lbl_coin.color = c_aim;
      }
    }
  };

  _proto.initLine = function initLine() {
    this._lineUnlock = App.DataMgr.lineUnlock;
    var allLine = this.sv_line.getComponent(ScrollView).content.children;
    var n_mask = null;
    var n_lock = null;
    var n_adTip = null;
    var isUnlock = false;
    var isOwn = false;

    for (var i = 0; i < allLine.length; i++) {
      n_lock = allLine[i].getChildByName("n_lock");
      isUnlock = this._lineUnlock.indexOf(i + "") != -1; //解锁状态

      n_lock.active = !isUnlock; //toggle enable

      allLine[i].getComponent(Toggle).enabled = isUnlock;

      if (isUnlock) {
        n_mask = allLine[i].getChildByName("n_mask");
        n_adTip = allLine[i].getChildByName("n_adTip"); //是否拥有

        isOwn = this._lineOwn.indexOf(i + "") != -1;
        n_mask.active = !isOwn;
        n_adTip.active = !isOwn;
      }
    }
  }
  /**更新购买 */
  ;

  _proto.updateGain = function updateGain() {
    if (this._type_select == E_ShopType.Ball) {
      var _content;

      var n_cur = (_content = this.sv_ball.getComponent(ScrollView).content) === null || _content === void 0 ? void 0 : _content.children[this._ballSelet];
      var n_mask = n_cur.getChildByName("n_mask");
      var n_coin = n_cur.getChildByName("coinTIp");
      var n_lblCoin = n_cur.getChildByName("lbl_coin");
      n_lblCoin.active = false;
      n_coin.active = false;
      n_mask.active = false;
    } else {
      var _content2;

      var _n_cur = (_content2 = this.sv_line.getComponent(ScrollView).content) === null || _content2 === void 0 ? void 0 : _content2.children[this._lineSelect];

      var _n_mask = _n_cur.getChildByName("n_mask");

      var n_adTip = _n_cur.getChildByName("n_adTip");

      _n_mask.active = false;
      n_adTip.active = false;
    }

    this.n_ad.active = false;
    this.n_buy.active = false;
  }
  /**更新球 */
  ;

  _proto.updateShow_ball = function updateShow_ball() {
    var _this2 = this;

    App.ResMgr.getTex(E_ResPath.Tex_BallRoot + this._texArr.get(this._ballSelet), function (tex) {
      var mat = _this2.n_ball.getComponent(MeshRenderer).materials[0];

      mat.setProperty("mainTexture", tex);
    }); // let mat = this.n_ball.getComponent(MeshRenderer)!.materials[0]!;
    // mat.setProperty("mainTexture", this.texArr[this._ballSelet]);
  }
  /**更新 线 */
  ;

  _proto.updateShow_line = function updateShow_line() {
    this.n_lineShow.getComponent(Sprite).color = this._lineCArr[this._lineSelect];
  };

  _proto.handle_adSucc = function handle_adSucc() {
    if (App.AdCtrl.type == E_AdType.ShopLine) {
      this.gain();
      this.updateGain();
    } else if (App.AdCtrl.type == E_AdType.ShopBall) {
      App.DataMgr.coin += 500;
      App.GameCtrl.flyAmn(E_PoolType.Coin, this.n_adCoin.worldPosition, this.n_coin.worldPosition, 8);
      this.updateCoin();
      this.updateBallState();
      this.updateSelect_ball();
    }
  };

  _proto.gain = function gain() {
    App.SoundMgr.playEffectType(E_SoundType.BuySucc);

    if (this._type_select == E_ShopType.Ball) {
      this._ballCur = this._ballSelet;
      this._ballOwn += "," + this._ballSelet;
      App.DataMgr.ballOwn = this._ballOwn;
      App.DataMgr.coin -= this._ballPrice[this._ballSelet];
      this.updateCoin();
      App.EventMgr.handleEvent(E_EventType.Tip_Shop, this._ballName[this._ballSelet]);
    } else {
      this._lineCur = this._lineSelect;
      this._lineOwn += "," + this._lineSelect;
      App.DataMgr.lineOwn = this._lineOwn;
      App.EventMgr.handleEvent(E_EventType.Tip_Shop, "新绳子");
    }
  };

  _proto.exit = function exit() {
    App.GameCtrl.isSwitch = true;
    App.DataMgr.lineCur = this._lineCur;
    App.DataMgr.ballCur = this._ballCur; // App.ResMgr.getTex(E_ResPath.Tex_BallRoot + this._texArr.get(this._ballCur), (tex: Texture2D) => {
    //     let mat = App.GameCtrl.ball_game.getChildByName("n_ball")!.getComponent(MeshRenderer)!.materials[0]!;
    //     mat.setProperty("mainTexture", tex);
    // });

    App.EventMgr.handleEvent(E_EventType.Ball_Change, this._lineCur); // App.GameCtrl.line_draw.getComponent(Line)!.color.color = this._lineCArr[this._lineCur];

    App.GameCtrl.line_game.getComponent(Line).color.color = this._lineCArr[this._lineCur];
    tween(this.node).to(0.5, {
      position: v3(App.DataMgr.visibleSize.width, 0, 0)
    }, {
      easing: "sineInOut"
    }).call(function () {
      App.GameCtrl.isSwitch = false;
      App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Hall);
    }).start();
  }
  /**点击事件 */
  ;

  _proto.btn_event = function btn_event(btn) {
    var nameTemp = btn.node.name;

    switch (nameTemp) {
      case "n_ad":
        App.AdCtrl.type = E_AdType.ShopLine;

        if (App.AdCtrl.platformType == E_PlatformType.Normal) {
          this.handle_adSucc();
        } else {
          App.AdCtrl.showRewardedVideoAd();
        }

        break;

      case "n_buy":
        if (App.DataMgr.coin >= this._ballPrice[this._ballSelet]) {
          this.gain();
          this.updateGain();
        }

        break;

      case "n_adCoin":
        App.AdCtrl.type = E_AdType.ShopBall;

        if (App.AdCtrl.platformType == E_PlatformType.Normal) {
          this.handle_adSucc();
        } else {
          App.AdCtrl.showRewardedVideoAd();
        }

        break;

      case "n_close":
        this.exit();
        break;
    }

    if (nameTemp.indexOf("tg_switch_") != -1) {
      this.btn_switch(nameTemp);
    } else if (nameTemp.indexOf("n_ballItem") != -1) {
      this.btn_ball(nameTemp);
    } else if (nameTemp.indexOf("n_lineItem") != -1) {
      this.btn_line(nameTemp);
    }
  };

  _proto.btn_ball = function btn_ball(tgName) {
    var name = tgName;
    var nameArr = name.split("-");
    var index = nameArr[nameArr.length - 1];
    this._ballSelet = parseInt(index);
    this.updateSelect_ball();
  };

  _proto.updateSelect_ball = function updateSelect_ball() {
    var isOwn = this._ballOwn.indexOf(this._ballSelet + "") != -1;

    if (isOwn) {
      this.n_buy.active = false;
      this.n_adCoin.active = false;
      this._ballCur = this._ballSelet;
    } else if (App.DataMgr.coin >= this._ballPrice[this._ballSelet]) {
      this.n_buy.active = true;
      this.n_adCoin.active = false;
    } else {
      this.n_buy.active = false;
      this.n_adCoin.active = true;
    }

    this.updateShow_ball();
  };

  _proto.btn_line = function btn_line(tgName) {
    var name = tgName;
    var nameArr = name.split("-");
    var index = nameArr[nameArr.length - 1];
    this._lineSelect = parseInt(index);
    this.updateSelect_line();
  };

  _proto.updateSelect_line = function updateSelect_line() {
    var isOwn = this._lineOwn.indexOf(this._lineSelect + "") != -1;

    if (isOwn) {
      this._lineCur = this._lineSelect;
    }

    this.n_ad.active = !isOwn;
    this.updateShow_line();
  };

  _proto.btn_switch = function btn_switch(tgName) {
    var _this3 = this;

    var curType = tgName == "tg_switch_1" ? E_ShopType.Ball : E_ShopType.Line;
    if (this._type_select == curType) return;
    this._type_select = curType;
    var isActive_ball = false;
    var isActive_line = false;
    var xAim_svBall = 0;
    var xAim_svLine = 0;

    if (curType == E_ShopType.Ball) {
      isActive_ball = true;
      xAim_svBall = 0;
      xAim_svLine = App.DataMgr.visibleSize.width;
    } else {
      isActive_line = true;
      xAim_svBall = -App.DataMgr.visibleSize.width;
      xAim_svLine = 0;
    }

    this.sv_ball.active = true;
    this.sv_line.active = true;
    tween(this.sv_ball).to(0.2, {
      position: v3(xAim_svBall, this.sv_ball.position.y, 0)
    }, {
      easing: "sineInOut"
    }).call(function () {
      if (!isActive_ball) {
        _this3.sv_ball.active = false;
      }
    }).start();
    tween(this.sv_line).to(0.2, {
      position: v3(xAim_svLine, this.sv_line.position.y, 0)
    }, {
      easing: "sineInOut"
    }).call(function () {
      if (!isActive_line) {
        _this3.sv_line.active = false;
      }
    }).start(); // this.sv_ball.active = isActive_ball;
    // this.sv_line.active = isActive_line;

    this.n_ad.active = isActive_line;
    this.n_buy.active = isActive_ball;
    this.n_adCoin.active = isActive_ball;

    if (this._type_select == E_ShopType.Ball) {
      this.updateSelect_ball();
    } else {
      this.updateSelect_line();
    }
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return Shop;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "n_coin", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "lbl_coin", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "n_close", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "n_title", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "n_lineShow", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "n_ballShow", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "n_ball", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "sv_ball", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "sv_line", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "n_ad", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "n_adCoin", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "n_buy", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "texArr", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();